import { createStore } from 'effector';
import { PayinTicketPriority, type PayinTicketFilters } from '~/entities/payin';
import { setTicketsFilter } from './events';

export const $ticketsFilter = createStore<PayinTicketFilters>({
    priorities: [PayinTicketPriority.PRIORITY_HIGH],
}).on(setTicketsFilter, (src, payload) => ({
    ...src,
    ...payload,
}));
